import api from '@/utils/api';

/**
 * Create Company Template
 * @param {string} companyId - the companyId
 * @param {object} data - The category data
 * @returns {Promise}
 */
const createCompanyTemplateApi = (companyId, data) =>
  api.post(`/company/${companyId}/template`, data);

export default createCompanyTemplateApi;
